import { render, staticRenderFns } from "./RestaurantOrderEdit.vue?vue&type=template&id=c1390380&"
import script from "./RestaurantOrderEdit.vue?vue&type=script&lang=js&"
export * from "./RestaurantOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports